import React from "react";
import ReactDOM from "react-dom/client";
import "semantic-ui-css/semantic.min.css";
import App from "./App";
import "./App.css";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { initializeActivityLogRequestTracking } from "./lib/activityLogQueryParam";
import { setupAuthInterceptor } from "./lib/authInterceptor";

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

initializeActivityLogRequestTracking();
setupAuthInterceptor();

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
